import React from 'react'
import { motion } from 'framer-motion'
import styles from '@/styles/finishingMove.module.scss'
import type { FinisherId } from '@/types/finisher'

const LABELS: Record<FinisherId, string> = {
  funny: 'BONK!',
  brutality: 'SMASH!',
  animality: 'BEAST!',
}

interface FinisherRevealProps {
  id: FinisherId
}

// Slams the picked finisher's name in for ~900 ms at the start of the
// executing phase. Mortal-Kombat-announcer beat — tells the loser what just
// hit them and celebrates the winner's choice.
const FinisherReveal: React.FC<FinisherRevealProps> = ({ id }) => {
  const themeClass =
    id === 'brutality'
      ? styles.revealBrutality
      : id === 'animality'
        ? styles.revealAnimality
        : styles.revealFunny

  return (
    <div className={styles.reveal} data-testid='finishing-move-reveal' data-finisher={id}>
      <motion.div
        className={`${styles.revealText} ${themeClass}`}
        initial={{ scale: 2.6, opacity: 0, y: 18 }}
        animate={{ scale: [2.6, 1, 1, 0.92], opacity: [0, 1, 1, 0], y: 0 }}
        transition={{ duration: 0.9, times: [0, 0.15, 0.7, 1], ease: [0.16, 1, 0.3, 1] }}
      >
        {LABELS[id]}
      </motion.div>
    </div>
  )
}

export default FinisherReveal
